<template>
    <div class="row">
        <div>
            <template v-if="currentPlan.otherServices!=futurePlan.otherServices">
                <h5>
                    <span class="highlight">Updated Services: </span>
                    <p v-html="futurePlan.otherServices"></p>
                </h5>
            </template>

        </div>
        <div>
            <h5>Effective {{ futurePlan.effectiveDate | shortDate }}</h5>
            <plan-settings :plan="currentPlan" :future-plan="futurePlan" :showOnlyOffered="true">

            </plan-settings>
        </div>
    </div>
</template>

<script>
    import PlanSettings from "./PlanSettings.vue";
    import {mapGetters} from "vuex";

    export default {
        name: "PlanChanges",
        components: {PlanSettings},
        props: {currentPlan: {type: [Object], required: true}, futurePlan: {type: [Object], required: true}},
        data() {
            return {
                widgetReady: false,
            }
        },
        computed: {
            hasCustomContent() {
                return Boolean(this.$scopedSlots.default);
            },
            ...mapGetters({showPricing: 'globalSettings/showPricing'})
        },
        async mounted() {
            this.widgetReady = true;
        },
        methods: {}
    }
</script>

<style scoped>
    .highlight {
        background-color: yellow;
        max-width: 275px;
        padding: 2px;
    }
</style>